import { request } from "../../utils/request";
import { VIDEO_CDN_PREFIX } from "../../config/video";
import { rewriteAbsoluteMediaUrlForPage } from "../../utils/videoUrl";

export const getTimbreDesignTemplateApi = () =>
  request<TimbreDesign.TemplateResponse>("/video/timbre-design/template", {
    method: "GET",
  });

function asFlag(value: unknown): boolean {
  return value === true || value === 1 || value === "true" || value === "1";
}

export const mapTimbreDesignRowToVoiceToneItem = (
  row: TimbreDesign.TimbreDesignPageItem
): VoicePublic.VoiceToneItem => {
  const audioUrl = (row.audioUrl || "").trim();
  return {
    id: row.id,
    voiceName: row.voiceName ?? "",
    description: row.description ?? "",
    langCode: row.langCode ?? "",
    genderValue: String(row.genderValue ?? ""),
    ageValue: String(row.ageValue ?? ""),
    timbreValue: String(row.timbreValue ?? ""),
    soundTextValue: row.soundTextValue ?? "",
    genderTextValue: row.genderTextValue ?? "",
    timbreTextValue: row.timbreTextValue ?? "",
    ageTextValue: row.ageTextValue ?? "",
    audioUrl,
    cloneAudioUrl: audioUrl || undefined,
    cloneText: (row.originText ?? "").trim() || undefined,
    cloneFinished: asFlag(row.cloneFinished),
    cloneFailed: asFlag(row.cloneFailed),
    published: Boolean(row.published),
    createTime: row.createTime ?? "",
    updateTime: row.updateTime ?? "",
  };
};

export const getTimbreDesignPageApi = (params: TimbreDesign.TimbreDesignPageQuery) =>
  request<TimbreDesign.TimbreDesignPageResponse>("/video/timbre-design/page", {
    method: "GET",
    params,
  });

export const getTimbreDesignAdminPageApi = (params: TimbreDesign.TimbreDesignAdminPageQuery) =>
  request<TimbreDesign.TimbreDesignPageResponse>("/video/timbre-design/admin/page", {
    method: "GET",
    params,
  });

export const getTimbreDesignByIdApi = (id: number) =>
  request<TimbreDesign.TimbreDesignGetResponse>("/video/timbre-design/get", {
    method: "GET",
    params: { id },
  });

export const deleteTimbreDesignApi = (id: number) =>
  request<TimbreDesign.TimbreDesignDeleteResponse>("/video/timbre-design/delete", {
    method: "DELETE",
    params: { id },
  });

export const resolveTimbreDesignPreviewUrl = (
  audioUrl: string,
  cdnPrefix: string = VIDEO_CDN_PREFIX
): string => {
  const raw = (audioUrl || "").trim();
  if (!raw) return "";
  if (raw.startsWith("http://") || raw.startsWith("https://")) {
    return rewriteAbsoluteMediaUrlForPage(raw, cdnPrefix);
  }
  const path = raw.startsWith("/") ? raw : `/${raw}`;
  return `${cdnPrefix}${path}`;
};

export const postTimbreDesignGenerateApi = (body: TimbreDesign.GenerateParams) =>
  request<TimbreDesign.GenerateResponse>("/video/timbre-design/generate-mimo", {
    method: "POST",
    body,
  });

export const postTimbreDesignSaveApi = (body: TimbreDesign.SaveParams) =>
  request<TimbreDesign.SaveResponse>("/video/timbre-design/save", {
    method: "POST",
    body,
  });

export const putTimbreDesignUpdateApi = (body: TimbreDesign.UpdateParams) => {
  const formData = new FormData();
  formData.append("id", String(body.id));
  formData.append("voiceName", body.voiceName);
  if (body.description !== undefined) {
    formData.append("description", body.description);
  }
  formData.append("langCode", body.langCode);
  formData.append("genderValue", body.genderValue);
  formData.append("ageValue", body.ageValue);
  formData.append("timbreValue", body.timbreValue);
  formData.append("text", body.text);
  if (body.audioFile) {
    formData.append("audioFile", body.audioFile);
  }
  return request<TimbreDesign.UpdateResponse>("/video/timbre-design/update", {
    method: "PUT",
    body: formData,
  });
};

export const postTimbreDesignCloneStartApi = (body: TimbreDesign.CloneStartParams) => {
  const formData = new FormData();
  formData.append("audioFile", body.audioFile);
  return request<TimbreDesign.CloneStartResponse>("/video/timbre-design/clone/start", {
    method: "POST",
    params: { text: body.text },
    body: formData,
  });
};

export const postTimbreDesignCloneSaveApi = (body: TimbreDesign.CloneSaveParams) =>
  request<TimbreDesign.CloneSaveResponse>("/video/timbre-design/clone/save", {
    method: "POST",
    body,
  });